<template>
<Head>
    <title>Wakaf Pahang - Pembayaran wakaf dalam talian</title>
    <meta name="description" content="Mari kita berwakaf di Wakaf Pahang. Semai di dunia, tuai di akhirat. Semoga Allah terima amalan kita." />
    <meta name="keywords" content="Wakaf Pahang, Pahang, Wakaf, Islam, Islam Indah, Muslim, Pahala, Infaq Ramadan, Ramadan" />
    <meta property="og:url" :content="uri" />
    <meta property="og:title" content="Wakaf Pahang - Pembayaran wakaf dalam talian" />
    <meta property="og:description" content="Mari kita berwakaf di Wakaf Pahang. Semai di dunia, tuai di akhirat. Semoga Allah terima amalan kita." />
    <meta property="og:type" content="website" />
    <meta property="og:image" :content="uri + '/img/og/payment2.png'" />
    <meta property="og:image:secure_url" :content="uri +'/img/og/payment2.png'" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="627" />
    <meta property="og:site_name" content="Pembayaran wakaf dalam talian" />
    <meta property="og:locale" content="ms_MY" />
    <meta property="twitter:url" :content="uri" />
    <meta property="twitter:title" content="Wakaf Pahang - Pembayaran wakaf dalam talian" />
    <meta property="twitter:description" content="Mari kita berwakaf di Wakaf Pahang. Semai di dunia, tuai di akhirat. Semoga Allah terima amalan kita." />
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:image" :content="uri +'/img/og/payment2.png'" />
    <meta property="twitter:image:width" content="1200" />
    <meta property="twitter:image:height" content="627" />
    <meta property="twitter:domain" content="Wakaf Pahang" />
    <meta property="twitter:locale" content="ms_MY" />
    <link rel="preload" fetchpriority="high" as="image" :href="img_wakafpahang" type="image/webp">
    <link rel="preload" fetchpriority="high" as="image" :href="ezid_logo" type="image/webp">
    <link rel="shortcut apple-touch-icon icon" as="image" :href="img_favicon" type="image/png">
</Head>

<header class="container-fluid py-2 bg-wakaf-primary">
    <div class="container-md d-flex flex-wrap">
        <div class="d-flex flex-wrap justify-content-center">
            <img :src="img_wakafpahang" decoding="async" class="me-3" width="200" height="57" style="margin-top: 7px" alt="Selamat datang ke Wakaf Pahang" />
            <div class="d-flex flex-column align-items-md-max-center">
                <span class="fs-6 text-white">Pembayaran wakaf dalam talian</span>
                <span class="fs-6 text-white">Semai di dunia, tuai di akhirat</span>
                <a href="tel:609514151" class="fs-6 text-white"><font-awesome-icon :icon="faPhone" class="me-1" /> 09-514 5151</a>
            </div>
        </div>
    </div>
</header>
<form method="post" @submit.prevent="submitForm">
    <section class="container-md pt-3" style="padding-bottom: 5rem">
        <div class="row">
            <div class="col">
                <p class="fs-5">Jika anda pernah berwakaf <span
                    class="btn btn-warning"><a :href="ezid_url" target="_blank"
                                               class="text-dark fw-bold text-decoration-none mt-4">
                    <img :src="ezid_logo" height="20" width="20" alt="Logo Ezid" decoding="async"> Log Masuk ke E-Zid</a></span>
                    <button class="btn btn-danger px-3 float-end "
                            :class="[showCloseBtn ? 'd-sm-block ' : 'd-none']" style="right: 0"
                            @click="cancelFormSubmit"
                            type="button"><font-awesome-icon :icon="faXmark" class="me-1" /> Batal
                    </button>
                </p>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-4">
                <div class="mb-3">
                    <label class="form-label" for="namPembayar">Nama</label>
                    <input v-model="wakaf.Nama" id="namPembayar" type="text" class="form-control" ref="nameRef"
                           :class="{'is-invalid': wakaf.error.Nama.flag}"
                           @input="updateWakafDataSendiriOption(($event.target as HTMLInputElement).value)"
                           placeholder="Nama penuh anda seperti dalam kad pengenalan">
                    <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.Nama.flag }">
                        {{ wakaf.error.Nama.message }}
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label" for="NoTelPembayar">No. Telefon Bimbit</label>
                    <input v-model="wakaf.TelefonBimbit" id="NoTelPembayar" type="text" class="form-control"
                           :class="{'is-invalid': wakaf.error.TelefonBimbit.flag}"
                           placeholder="Nombor telefon bimbit yang aktif">
                    <div class="form-text">Contoh: 0129012345</div>
                    <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.TelefonBimbit.flag }">
                        {{ wakaf.error.TelefonBimbit.message }}
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mb-3">
                    <label class="form-label" for="noKPPembayar">No. Kad Pengenalan Diri</label>
                    <input v-model="wakaf.NoKP" id="noKPPembayar" type="text" class="form-control"
                           :class="{'is-invalid': wakaf.error.NoKP.flag}"
                           placeholder="No. MyKad/Passport/Anggota" @focusout="formatIC">
                    <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.NoKP.flag }">
                        {{ wakaf.error.NoKP.message }}
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label" for="emelPembayar" >E-mel</label>
                    <input v-model="wakaf.EMel" id="emelPembayar" type="email" class="form-control"
                           :class="{'is-invalid': wakaf.error.EMel.flag}"
                           placeholder="Alamat e-mel yang aktif">
                    <div class="form-text">Contoh: ahmad@wakafpahang.my</div>
                    <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.EMel.flag }">
                        {{ wakaf.error.EMel.message }}
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mb-3">
                    <label class="form-label" for="daerahPembayar">Daerah pembayar</label>
                    <select class="form-select" id="daerahPembayar" v-model="wakaf.daerahPembayar"
                        :class="{'is-invalid': wakaf.error.daerahPembayar.flag}">
                        <option value="0" selected disabled>Sila Pilih</option>
                        <template v-for="daerah in district">
                            <option v-if="daerah.KodDaerah !== 12" :value="daerah.KodDaerah" class="text-capitalize">{{ daerah.Daerah }}</option>
                        </template>
                    </select>
                    <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.daerahPembayar.flag }">
                        {{ wakaf.error.daerahPembayar.message }}
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column">
            <span class="fs-6 fst-italic">Sila tekan butang <b>Tambah</b> untuk berwakaf.</span>
            <span class="fs-6 fst-italic">Setiap pembayaran melalui FPX akan dikenakan cas sebanyak 50 sen</span>
        </div>
        <transaction-public ref="wakafDataRef" :wakaf_type='wakaf_type' :wakaf_district='wakaf_district' :wakaf_project='wakaf_project'
                    :nama_pewakaf="wakaf.Nama" :w_id="data.wid" :d_id="data.did" :p_id="data.pid"
                    @update-name="updateNameParent" @calulate-sum="calculateSum"></transaction-public>
        <div v-if="isDisplayGrandSumAndSubmit" class="d-flex justify-content-center mb-3 position-relative">
            <p class="fs-5 fw-bold text-break btn btn-outline-primary">Jumlah keseluruhan :
                {{ sumFormat(sum) }}</p>
            <button class="btn btn-success position-absolute px-4 d-none d-sm-block" style="right: 0" type="submit">
                <font-awesome-icon :icon="faPaperPlane" class="me-2" />Hantar
            </button>
        </div>
        <div v-if="isDisplayGrandSumAndSubmit" class="d-flex justify-content-end mb-3">
            <button class="btn btn-success px-4 d-block d-sm-none" type="submit"><font-awesome-icon :icon="faPaperPlane" />Hantar
            </button>
        </div>
    </section>
</form>
<!--<footerFPX class="mt-5" :year="currentYear"></footerFPX>-->
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import { Head } from '@inertiajs/vue3';
import axios from "axios";
import Swal from "sweetalert2";
import { sumFormat } from "@/utils/utils";
import { type Pewakaf} from "../interface/Pewakaf";
import transactionPublic from "./transactionPublic.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPaperPlane, faXmark, faPhone } from "@fortawesome/free-solid-svg-icons";
import type {FormGeneral} from "../interface/FormGeneral";
library.add(faPaperPlane, faXmark, faPhone);


const sum: Ref = ref<number>(0);
const nameRef: Ref = ref<HTMLInputElement>();
const showCloseBtn: Ref = ref<boolean>(false);
const wakafDataRef: Ref = ref<InstanceType<typeof transactionPublic> | null>(null);
const isDisplayGrandSumAndSubmit: Ref = ref<boolean>(false);

const data = defineProps<{
    img_wakafpahang: string,
    img_wakafconfrim: string,
    ezid_url: string,
    img_favicon: string,
    csrf: string,
    submit_url: string,
    ezid_logo: string,
    district: [{
        KodDaerah: number,
        Daerah: string,
    }],
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    currentYear: number,
    uri: string,
    wid?: number,
    did?: number,
    pid?: number | string,
}>();

const wakaf = ref<Pewakaf>({
    Nama: "",
    TelefonBimbit: "",
    daerahPembayar: 0,
    NoKP: "",
    EMel: "",
    error:{
        Nama: {
            flag: false,
            message:""
        },
        TelefonBimbit: {
            flag: false,
            message:""
        },
        NoKP: {
            flag: false,
            message:""
        },
        EMel: {
            flag: false,
            message:""
        },
        daerahPembayar: {
            flag: false,
            message:""
        }
    }
});

// const wakafDataRef = ref(null)
// const version = computed(() => wakafDataRef.value?.version)

onMounted(() => {
    nameRef.value.focus()
    if (window.opener !== null) {
        showCloseBtn.value = true;
    }
});

const updateNameParent = (name: string, type: string): void => {
    if (type === "Sendiri") {
        wakaf.value.Nama = name;
    }
}
const updateWakafDataSendiriOption = (name: string): void => {
    wakafDataRef.value.transactionPublic.forEach(function (item: FormGeneral, index: number) {
        if (wakafDataRef.value.transactionPublic[index].jenisPemilik === "Sendiri") {
            wakafDataRef.value.transactionPublic[index].namaPemilik = name;
        }
    })
}

const formatIC = (): void => {
    if (wakaf.value.NoKP.length === 12) {
        wakaf.value.NoKP = wakaf.value.NoKP.slice(0, 6) + "-" + wakaf.value.NoKP.slice(6, 8) + "-" + wakaf.value.NoKP.slice(8, 14);
    }
}
const calculateSum = (summ: number) : void =>{
    if(wakafDataRef.value.transactionPublic.length === 0) {
        isDisplayGrandSumAndSubmit.value = false;
        sum.value = 0;
    } else if (wakafDataRef.value.transactionPublic.length > 0) {
        isDisplayGrandSumAndSubmit.value = true;
        sum.value = summ;
    }
}

const submitForm = (): void => {
    let formValidation: boolean = true;
    wakaf.value.Nama = wakaf.value.Nama.trim();
    wakaf.value.TelefonBimbit = wakaf.value.TelefonBimbit.trim();
    wakaf.value.NoKP = wakaf.value.NoKP.trim();
    wakaf.value.EMel = wakaf.value.EMel.trim();
    wakaf.value.error.Nama.flag = false;
    wakaf.value.error.TelefonBimbit.flag = false;
    wakaf.value.error.NoKP.flag = false;
    wakaf.value.error.EMel.flag = false;
    wakaf.value.error.daerahPembayar.flag = false;
    if(wakaf.value.Nama.length <= 5 || wakaf.value.Nama.length > 150){
        formValidation = false;
        wakaf.value.error.Nama.flag = true;
        wakaf.value.error.Nama.message = "Sila masukkan nama yang sah";
    }
    // check only for mobile number
    if(!new RegExp("^(01)[02-46-9][0-9]{7}$|^(01)1[0-9]{8}$", "g").test(wakaf.value.TelefonBimbit)){
        formValidation = false;
        wakaf.value.error.TelefonBimbit.flag = true;
        wakaf.value.error.TelefonBimbit.message = "Sila masukkan nombor telefon bimbit yang sah";
    }
    if(wakaf.value.NoKP.length <= 5){
        formValidation = false;
        wakaf.value.error.NoKP.flag = true;
        wakaf.value.error.NoKP.message = "Sila masukkan nombor pengenalan diri yang sah";
    }
    if(wakaf.value.EMel.length <= 5 || wakaf.value.EMel.length > 150){
        formValidation = false;
        wakaf.value.error.EMel.flag = true;
        wakaf.value.error.EMel.message = "Sila masukkan emel yang sah";
    }
    if(wakaf.value.daerahPembayar === 0){
        formValidation = false;
        wakaf.value.error.daerahPembayar.flag = true;
        wakaf.value.error.daerahPembayar.message = "Sila pilih daerah anda";
    }
    if(formValidation){
        Swal.fire({
            title: "Anda pasti untuk hantar ?",
            html: `<p class="fs-6">Saya dengan ini mewakafkan nilai sebanyak <b> ${sumFormat(sum.value)}</b> selama-lamanya kerana Allah Ta'ala</p>
                    <p style="font-size: 12px" class="fst-italic">Tiada caj pengurusan akan diambil terhadap amaun wakaf. Pihak pengurusan hanya diizinkan mengambil caj pengurusan daripada hibah / keuntungan deposit wang wakaf (jika ada) pada kadar tidak melebihi separuh amaun hibah / keuntungan deposit.</p>
                   `,
            imageUrl: data.img_wakafconfrim,
            imageWidth: 128,
            imageHeight: 128,
            showConfirmButton: true,
            confirmButtonColor: "#198754",
            confirmButtonText: "Ya, saya wakafkan",
            showCancelButton: true,
            cancelButtonText: "Kembali",
            cancelButtonColor: "#0d6efd",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
            backdrop: true,
            reverseButtons: true,
            preConfirm: async() => {
                // return 0
                let jenisWakaff : number[] = [];
                let daerahWakaff : number[] = [];
                let projekWakaff : number[] = [];
                let unitt : number[] = [];
                let jumlahh : number[] = [];
                let jenisPemilikk : string[] = [];
                let namaPemilikk : string[] = [];
                wakafDataRef.value?.transactionPublic.forEach((item: FormGeneral) => {
                    jenisWakaff.push(item.jenisWakaf);
                    daerahWakaff.push(item.daerahWakaf);
                    projekWakaff.push(item.projekWakaf);
                    unitt.push(item.unit);
                    jumlahh.push(item.jumlah);
                    jenisPemilikk.push(item.jenisPemilik);
                    namaPemilikk.push(item.namaPemilik);
                })
                return axios({
                    method: "post",
                    url: data.submit_url,
                    data: {
                        csrf: data.csrf,
                        Nama: wakaf.value.Nama,
                        TelefonBimbit: wakaf.value.TelefonBimbit,
                        daerahPembayar: wakaf.value.daerahPembayar,
                        NoKP: wakaf.value.NoKP,
                        EMel: wakaf.value.EMel,
                        jenisWakaf: jenisWakaff,
                        daerahWakaf: daerahWakaff,
                        projekWakaf: projekWakaff,
                        unit: unitt,
                        jumlah: jumlahh,
                        jenisPemilik: jenisPemilikk,
                        namaPemilik: namaPemilikk,
                    }
                }).then(function (response) {
                    window.location.href = response.data;
                }).catch(function (error) {
                    Swal.fire({
                        icon: "error",
                        title: "Ralat berlaku",
                        text: "Sila cuba semula untuk hantar. " + error.body.message,
                        timer: 5000,
                        timerProgressBar: true,
                        confirmButtonColor: "#0d6efd",
                        confirmButtonText: "Ok",
                    })
                });
            },
        })
    }
}

const cancelFormSubmit = () => {
    Swal.fire({
        position: "top",
        icon: "question",
        title: "Anda pasti untuk batal?",
        showConfirmButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Ya",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd"
    }).then((result) => {
        if (result.isConfirmed) {
            window.close()
        }
    })
}

</script>
